import { Glasses, X } from "lucide-react";
import { Link } from "react-router-dom";
import { useEffect } from "react";

export default function MontureModal({ monture, onClose }) {
    useEffect(() => {
        const onKey = (e) => {
            if (e.key === "Escape") onClose();
        };
        window.addEventListener("keydown", onKey);
        document.body.style.overflow = "hidden";
        return () => {
            window.removeEventListener("keydown", onKey);
            document.body.style.overflow = "";
        };
    }, [onClose]);

    if (!monture) return null;
    const m = monture;

    return (
        <div
            className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-8 bg-lpl-text/70 backdrop-blur-sm"
            onClick={onClose}
            data-testid="monture-modal"
        >
            <div
                className="relative w-full max-w-5xl bg-lpl-bg shadow-2xl max-h-[90vh] overflow-y-auto"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    type="button"
                    onClick={onClose}
                    aria-label="Fermer"
                    data-testid="modal-close"
                    className="absolute top-4 right-4 z-10 w-11 h-11 rounded-full bg-lpl-primary text-lpl-text flex items-center justify-center hover:bg-lpl-text hover:text-lpl-bg transition-colors"
                >
                    <X size={20} />
                </button>

                <div className="grid grid-cols-1 md:grid-cols-2">
                    <div
                        className="aspect-square md:aspect-auto md:min-h-[520px] flex items-center justify-center overflow-hidden"
                        style={{ background: m.bg, color: m.fg }}
                    >
                        {m.image ? (
                            <img
                                src={m.image}
                                alt={`${m.marque} ${m.modele}`}
                                className="w-full h-full object-cover"
                            />
                        ) : (
                            <Glasses size={220} strokeWidth={1.2} />
                        )}
                    </div>
                    <div className="p-8 md:p-12 flex flex-col">
                        <p className="font-serif italic text-xl text-lpl-text-muted mb-2">
                            {m.marque}
                        </p>
                        <h3 className="font-display font-semibold text-4xl md:text-5xl text-lpl-text leading-[0.95] tracking-tight mb-6">
                            {m.modele}
                        </h3>
                        <p className="text-lg text-lpl-text-muted leading-relaxed mb-8 max-w-md">
                            {m.description}
                        </p>

                        <dl className="grid grid-cols-2 gap-x-6 gap-y-5 mb-10 max-w-md">
                            <div>
                                <dt className="text-xs uppercase tracking-[0.18em] text-lpl-text-muted font-semibold mb-1">
                                    Marque
                                </dt>
                                <dd className="font-display text-lg text-lpl-text">
                                    {m.marque}
                                </dd>
                            </div>
                            <div>
                                <dt className="text-xs uppercase tracking-[0.18em] text-lpl-text-muted font-semibold mb-1">
                                    Modèle
                                </dt>
                                <dd className="font-display text-lg text-lpl-text">
                                    {m.modele}
                                </dd>
                            </div>
                            <div>
                                <dt className="text-xs uppercase tracking-[0.18em] text-lpl-text-muted font-semibold mb-1">
                                    Matériau
                                </dt>
                                <dd className="font-display text-lg text-lpl-text">
                                    {m.materiau}
                                </dd>
                            </div>
                            <div>
                                <dt className="text-xs uppercase tracking-[0.18em] text-lpl-text-muted font-semibold mb-1">
                                    Couleur
                                </dt>
                                <dd className="font-display text-lg text-lpl-text">
                                    {m.couleur}
                                </dd>
                            </div>
                            <div className="col-span-2">
                                <dt className="text-xs uppercase tracking-[0.18em] text-lpl-text-muted font-semibold mb-1">
                                    Tarif
                                </dt>
                                <dd className="font-display text-lg text-lpl-text">
                                    {m.prix}
                                </dd>
                            </div>
                        </dl>

                        <Link
                            to="/contact"
                            onClick={onClose}
                            className="mt-auto inline-flex items-center justify-center gap-3 bg-lpl-primary text-lpl-text px-7 py-4 rounded-full text-sm uppercase tracking-[0.16em] font-semibold hover:bg-lpl-text hover:text-lpl-bg transition-colors duration-300"
                            data-testid="modal-cta-essayer"
                        >
                            La voir en boutique
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
